"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
document.addEventListener('DOMContentLoaded', () => {
    const preorderCheckout = document.querySelector('#preorder-checkout-button');
    if (preorderCheckout) {
        preorderCheckout.addEventListener('click', (e) => __awaiter(void 0, void 0, void 0, function* () {
            const eventValue = e.target;
            const productId = eventValue.getAttribute('product-id');
            if (productId) {
                const formData = new URLSearchParams();
                formData.append('quantity', '1');
                formData.append('form_type', 'product');
                formData.append('id', productId);
                try {
                    const response = yield fetch('/cart/add.js', {
                        method: 'post',
                        body: formData
                    });
                    if (response.ok) {
                        document.location.href = '/cart/checkout';
                    }
                    else {
                        console.log("Unable to add product to cart");
                    }
                }
                catch (e) {
                    console.log("Unable to add product to cart");
                }
                e.preventDefault();
            }
        }));
    }
});
